var chunkToChildrenMap = {
	"uc": [
		"vendors-node_modules_mui_icons-material_esm_AllInclusive_js-node_modules_mui_icons-material_e-b5713e",
		"b2b_common_components_FormControls_DateRangePicker_index_js-b2b_common_components_Reporting_F-ed32bb",
		"uc.dashboard"
	]
};
__webpack_require__.f.prefetch = function(chunkId, promises) { Promise.all(promises).then(function() {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}); };